import { render, staticRenderFns } from "./BookTestDrive.vue?vue&type=template&id=cdb48c68&"
import script from "./BookTestDrive.vue?vue&type=script&lang=js&"
export * from "./BookTestDrive.vue?vue&type=script&lang=js&"
import style0 from "./BookTestDrive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VCol,VContainer,VDatePicker,VRow})
